import { Color, Style, StyleFilters } from './style';
import { Category } from './category';
import { Brand } from './brand.model';
import { PaginationFilters } from './paginationFilters';
import { Team } from './team';
import { StyleGroup } from './style-group';
import { Shot } from './shot';

export class Template {
	id?: number;
	name?: string;
	brand?: Brand;
	category?: Category;
	isDefault?: boolean;
	styles?: Style[];
	shots?: Shot[];
	colors?: Color[]

	constructor(init?: Partial<Template>) {
		Object.assign(this, init);
	}
}

export class TemplateFilters extends PaginationFilters {
	brands?: Brand[];
	categories?: Category[];
	styleGroups?: StyleGroup[];
	teams?: Team[];

	constructor(init?: Partial<TemplateFilters>) {
		super(init);
		Object.assign(this, init);
	}
}
